import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const FormW2Mississippi = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Mississippi W-2 Form Filing Requirements for 2025."
          description="Learn about the Mississippi W-2 filing requirements for 2025 with TaxZerone. File Form W-2, Wage & Tax Statement, with the state by February 2. 2026! E-file now!"
          keywords=" "
          canonical="form-w2-state-filing/mississippi-w-2-filing-requirements/"
          jsonLdPricing="0.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/ms-state-landing-img.webp" />
                <source srcSet="/assets/images/ms-state-landing-img.png" />
                <img
                  src="/assets/images/ms-state-landing-img.png"
                  alt="Meet Mississippi's 2025 W-2 Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Meet{' '}
                <span className="highlight-container">
                  <span className="highlight">Mississippi&apos;s 2025 W-2</span>
                </span>{' '}
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                Filing Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Learn about Mississippi&apos;s W-2 filing rules and deadlines,
                and quickly E-file your W-2 forms with ease and accuracy.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2ms`}
                  >
                    E-File{' '}
                    <Box
                      component="span"
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box>
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: 1,
                      textAlign: 'center',
                      fontSize: { xs: 11, sm: 14 },
                    }}
                  >
                    As low as <b>$0.99 per</b> W-2 state filing form
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Box>
          {/* <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/ms-state-landing-img-sm.webp" />
                <source srcSet="/assets/images/ms-state-landing-img-sm.png" />
                <img
                  src="/assets/images/ms-state-landing-img-sm.png"
                  alt="Meet Mississippi's 2024 W-2 Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden> */}
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 4,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Key Mississippi W-2 Form Information
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                          }}
                        >
                          State Tax
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                          }}
                        >
                          Form
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                          }}
                        >
                          Filing Requirement
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            textAlign: 'center',
                            borderBottom: '1px solid #828282',
                          }}
                        >
                          Filing Method
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          rowSpan={2}
                          sx={{
                            borderRight: '1px solid #828282',
                            backgroundColor: '#fff',
                            textAlign: 'center',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            <b>Yes,</b>
                          </span>
                          <br /> Wages are taxable
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            {' '}
                            <b>Form W-2</b>
                          </span>
                          <br /> Wage and Tax Statement
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          Mandatory
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff',
                          }}
                        >
                          <span style={{ fontSize: 16 }}>
                            <b> Electronic</b>/Paper <br />
                          </span>
                          <span style={{ fontSize: 12, fontStyle: 'italic' }}>
                            {' '}
                            We recommend electronic filing.
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 2, pb: 2 }}
        >
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                Who Needs to File W-2 Forms in Mississippi?
              </Typography>
              <Typography variant="body1">
                Any employer withholding Mississippi state income tax must file
                <br /> <b> W-2 Forms</b> for the 2025 tax year. This includes
                reporting employee state-taxable earnings and the total amount
                of state income tax withheld. Whether you have a small business
                or a larger workforce, ensuring timely and accurate filing of
                W-2 forms is crucial for compliance with Mississippi state tax
                requirements.
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box>
              <picture>
                <source srcSet="/assets/images/ms-who-need-file-img.webp" />
                <source srcSet="/assets/images/ms-who-need-file-img.png" />
                <img
                  src="/assets/images/ms-who-need-file-img.png"
                  alt="Who Needs to File W-2 Forms in Mississippi?"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={400}
                  height={400}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid size={{ md: 6, xs: 12 }}>
              <Box>
                <picture>
                  <source srcSet="/assets/images/w2-form-dist-col-img.webp" />
                  <source srcSet="/assets/images/w2-form-dist-col-img.png" />
                  <img
                    src="/assets/images/w2-form-dist-col-img.png"
                    alt="What Must Be Filed?"
                    className="img-responsive"
                    loading="lazy"
                    width={459}
                    height={420}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                    lineHeight: 1.5,
                  }}
                >
                  What Must Be Filed?
                </Typography>
                <Typography component="div" variant="body1">
                  <ul style={{ marginBottom: 16 }}>
                    <li style={{ marginBottom: 8 }}>
                      <b>Form W-2:</b> Wage and Tax Statement for each employee
                    </li>
                  </ul>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive" textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Important W-2 Form Fields for Mississippi Filings
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/ms-w2-form-state-step-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/ms-w2-form-state-step-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/ms-w2-form-state-step-img.png"
                  alt="Important W-2 Form Fields for Mississippi Filings"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
                textAlign: 'center',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box>
                <Typography variant="body1">
                  Ensure the following key fields on the W-2 form are correctly
                  filled:
                </Typography>

                <Box
                  component="ol"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    p: 2,
                    pl: 0,
                    ml: { xs: 0, sm: 0, md: -2 },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <CheckCircleIcon
                        sx={{ color: '#1da94a', fontSize: 32, mt: 0.4 }}
                      />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Employer’s state ID number
                      </Typography>
                      <Typography variant="body1">
                        Enter the state and employer&apos;s state ID number in
                        <b> Box 15</b>. This is mandatory if Mississippi state
                        income tax is being withheld from the employee’s wages.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <CheckCircleIcon
                        sx={{ color: '#1da94a', fontSize: 32, mt: 0.4 }}
                      />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        State wages, tips, etc.
                      </Typography>
                      <Typography variant="body1">
                        Enter the total wages, tips, or other compensation in{' '}
                        <Hidden lgDown>
                          <br />
                        </Hidden>{' '}
                        <b>Box 16</b>. This amount should reflect what is
                        subject to Mississippi state income tax.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <CheckCircleIcon
                        sx={{ color: '#1da94a', fontSize: 32, mt: 0.4 }}
                      />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        State income tax
                      </Typography>
                      <Typography variant="body1">
                        Enter the amount of Mississippi state income tax
                        withheld from the employee’s wages in <b>Box 17</b>.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
              </Box>
              {/* <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                >
                  E-file Form W-2
                </Button>
                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: { xs: 2, sm: 2, md: 5 },
                    ml: { xs: 0, md: 3 },
                  }}
                >
                  Takes only 3 steps
                </Typography>
              </Box> */}
            </Box>
          </Stack>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="body1">
              TaxZerone makes filing Mississippi state W-2 forms simple and
              efficient, allowing you to complete the process in just a few easy
              steps.
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 4,

                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=stateformw2ms`}
            >
              File Mississippi W-2 Form
            </Button>
          </Box>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                State Filing Methods for Mississippi W-2 Forms
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ textAlign: 'center', alignItems: 'center' }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#efefef',
                      borderRadius: '50%',
                      width: 90,
                      height: 90,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      //  mx: 'auto',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <source
                        srcSet="/assets/images/electronically-icon.webp"
                        width={60}
                        height={60}
                      />
                      <source
                        srcSet="/assets/images/electronically-icon.png"
                        width={60}
                        height={60}
                      />
                      <img
                        src="/assets/images/electronically-icon.png"
                        alt="Electronic Filing"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>{' '}
                  </Box>
                  <Box sx={{}}>
                    <picture style={{ width: 83, height: 62 }}>
                      <source
                        srcSet="/assets/images/three-feature-icon.webp"
                        width={83}
                        height={62}
                      />
                      <source
                        srcSet="/assets/images/three-feature-icon.png"
                        width={83}
                        height={62}
                      />
                      <img
                        src="/assets/images/three-feature-icon.png"
                        alt="Electronic Filing"
                        loading="lazy"
                        width={83}
                        height={62}
                        className="three-feature-img"
                      />
                    </picture>{' '}
                  </Box>
                </Stack>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Electronic Filing
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Mississippi mandates employers e-file W-2 Forms when
                    submitting 25 or more. With TaxZerone, the process is
                    effortless!
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Just enter or upload your employees&apos; information,
                    review it, and hit submit. We&apos;ll take care of the rest
                    once it&apos;s transmitted.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/paper-filling-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/paper-filling-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/paper-filling-icon.png"
                      alt="Paper Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>{' '}
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 2,
                    }}
                  >
                    Paper Filing
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Employers in Mississippi have the option to paper file{' '}
                    <Hidden mdDown>
                      <br />
                    </Hidden>
                    W-2 forms if they are submitting 24 or fewer to the
                    Mississippi Department of Revenue.
                  </Typography>
                  <Stack
                    spacing={2}
                    direction={{ md: 'row', sm: 'row', xs: 'column' }}
                    sx={{ alignItems: 'start', flexGrow: 2 }}
                  >
                    <Box
                      sx={{
                        maxWidth: 300,
                        mb: 1,
                        p: 2,
                        border: '5px solid transparent',
                        borderRadius: 3,
                        background:
                          'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 0.8 }}
                      >
                        {' '}
                        <MailOutlineOutlinedIcon
                          sx={{
                            position: 'relative',
                            ml: 0,
                            mr: 0.5,
                            mb: -1,
                            fontSize: 28,
                          }}
                        />{' '}
                        Mailing Address:
                      </Typography>
                      <Box
                        component="div"
                        sx={{ textAlign: 'left', fontSize: '15px important' }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: 'italic' }}
                        >
                          Department of Revenue,
                          <br />
                          P. O. Box 960,
                          <br />
                          Jackson MS, 39205.
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </Box>
              </Paper>
            </Grid>{' '}
            <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'center',
                    mt: 2,
                    maxWidth: 800,
                    mx: 'auto',
                  }}
                >
                  <b> Recommendation:</b> E-filing with TaxZerone ensures faster
                  processing, accuracy, and ease, efficiently handling all your
                  W-2 forms from start to finish with minimal effort.
                </Typography>
                <Box>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 4,
                      mb: 2,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2ms`}
                  >
                    E-file W-2 Form Now!
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 5, md: 3, lg: 3 },
            //   borderRadius: { xs: 0, md: 4 },
            //   mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Grid
            container
            spacing={2}
            direction={{ sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
              className="responsive"
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: 'left',
                  }}
                >
                  Mississippi Form 89-140: W-2 Transmittal
                </Typography>

                <Typography variant="body1" sx={{ textAlign: 'left', mb: 2 }}>
                  Employers in Mississippi who file Form W-2 on paper must
                  submit Transmittal Form 89-140 along with the W-2 forms to the
                  Mississippi Department of Revenue for accurate reporting of
                  wages and tax withholding. The forms should be sent to the
                  following address:
                </Typography>

                <Box
                  sx={{
                    maxWidth: 300,
                    mb: 1,
                    p: 2,
                    border: '5px solid transparent',
                    textAlign: 'left',
                    borderRadius: 3,
                    background:
                      'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                    {' '}
                    <MailOutlineOutlinedIcon
                      sx={{
                        position: 'relative',
                        ml: 0,
                        mr: 0.5,
                        mb: -1,
                        fontSize: 28,
                      }}
                    />{' '}
                    Mailing Address:
                  </Typography>
                  <Box
                    component="div"
                    sx={{ textAlign: 'left', fontSize: '15px important' }}
                  >
                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                      Department of Revenue,
                      <br />
                      Withholding Tax Division,
                      <br />
                      P.O. Box 23058
                      <br />
                      Jackson, MS 39225-3058
                    </Typography>
                  </Box>
                </Box>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{
                    mt: 2,
                    mb: 0,
                    textAlign: 'left',
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <b>Note:</b> Employers filing W-2s electronically are{' '}
                  <b> Not required</b> to file <br />
                  Form 89-140.
                </Alert>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                  // BorderRadius: '24px',
                  // boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                  // position: 'relative',
                  // zIndex: 1,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/ms-state-transmitted-form-img.webp" />
                  <source srcSet="/assets/images/ms-state-transmitted-form-img.png" />
                  <img
                    src="/assets/images/ms-state-transmitted-form-img.png"
                    alt="Mississippi Form 89-140: W-2 Transmittal"
                    className="img-responsive-boir"
                    loading="lazy"
                    width={490}
                    height={448}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pt: 8,
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="xl" sx={{ pt: 5, mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/ms-state-correction-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/ms-state-correction-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/ms-state-correction-img.png"
                  alt="W-2c Corrections for Mississippi filings"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
                textAlign: 'left',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                    textAlign: { md: 'left', sm: 'center', xs: 'center' },
                    lineHeight: 1.5,
                  }}
                >
                  W-2c Corrections for Mississippi filings
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    mb: 2,
                    textAlign: { md: 'left', sm: 'center', xs: 'center' },
                  }}
                >
                  To correct errors on previously filed W-2 forms in
                  Mississippi, you must submit{' '}
                  <Link
                    href="/information-returns/efile-irs-form-w2-c/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form W-2c
                  </Link>
                  . This form enables you to fix mistakes in reported wages,
                  taxes, or employee details. Filing a W-2c ensures your records
                  are accurate and comply with Mississippi state reporting
                  requirements.
                </Typography>
              </Box>
            </Box>
          </Stack>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              TaxZerone makes it simple to file Form W-2c and correct errors on
              your W-2 forms. Our platform streamlines the process,
              <Hidden mdDown>
                <br />
              </Hidden>{' '}
              ensuring your corrections are submitted accurately.
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 2,
                mb: 4,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2c`}
            >
              File W-2c Now!
            </Button>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 1,
              textAlign: 'center',
            }}
          >
            Filing Deadline for Mississippi W-2 Forms
          </Typography>

          <Box
            sx={{
              mb: 2,
              maxWidth: '100%',

              mx: 'auto',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              width: 700,
            }}
          >
            <Box component="div" sx={{ mb: 2 }}>
              <TableContainer
                sx={{ border: '1px solid #828282', borderRadius: 3 }}
              >
                <Table sx={{}} aria-label="Due Date Chart">
                  <TableHead>
                    <TableRow
                      sx={{ textAlign: 'center', backgroundColor: '#ccc' }}
                    >
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          borderRight: '1px solid #828282',
                          width: 300,
                          fontSize: '20px !important',
                          fontWeight: 600,
                        }}
                      >
                        Form
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          width: 300,
                          fontSize: '20px !important',
                          textAlign: 'center',
                        }}
                      >
                        Deadline
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow sx={{ textAlign: 'center' }}>
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          borderRight: '1px solid #828282',
                          width: 300,
                          borderBottom: '1px solid #828282',
                          backgroundColor: '#fff',
                        }}
                      >
                        <b> Form W-2</b>
                        <br />
                        (Wage and Tax Statement)
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          width: 300,
                          fontSize: '20px !important',
                          textAlign: 'center',
                          color: '#dd1c1a',
                          borderBottom: '1px solid #828282',
                          backgroundColor: '#fff',
                        }}
                      >
                        February 2, 2026
                      </TableCell>
                    </TableRow>
                    <TableRow
                      sx={{
                        backgroundColor: '#f9f9f9',
                        textAlign: 'center',
                      }}
                    >
                      <TableCell
                        sx={{
                          textAlign: 'center',
                          width: 300,
                          borderRight: '1px solid #828282',
                        }}
                      >
                        <b> Form 89-140</b> <br />
                        (Transmittal form for W-2 in Mississippi)
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 600,
                          width: 300,
                          fontSize: '20px !important',
                          textAlign: 'center',
                          color: '#dd1c1a',
                        }}
                      >
                        March 2, 2026
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Alert
              severity="warning"
              icon={false}
              sx={{
                mt: 1,
                mb: 0,
                alignItems: 'end',
                borderLeft: '3px solid rgb(102, 60, 0)',
              }}
            >
              <b>Note:</b> If the deadline falls on a weekend or holiday, it is
              extended to the next business day.
            </Alert>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Why Choose TaxZerone for Mississippi W-2 State Filing?
          </Typography>
          <Typography
            variant="body1"
            sx={{ maxWidth: 900, mx: 'auto', textAlign: 'center', mb: 3 }}
          >
            When it comes to e-filing W-2 forms, TaxZerone stands out as your
            go-to solution. Our platform is designed to make the filing process
            easy, accurate, and timely. Experience the following benefits:
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  borderWidth: 3,
                  borderColor: '#626262',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Quick & Easy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Quick & Easy
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Complete your W-2 filings in just three simple steps, taking
                  less than five minutes!
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  borderWidth: 3,
                  borderColor: '#626262',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: '18px !important',
                    mt: 2,
                    mb: 1,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Each form costs only <b>$0.99</b> for w2 state filings with
                  absolutely no hidden fees.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  borderWidth: 3,
                  borderColor: '#626262',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Upload Feature"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 600, fontSize: '18px !important', mb: 1 }}
                >
                  Bulk Upload Feature
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Save valuable time by uploading multiple forms in one go.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#fff',
                  p: 4,
                  borderRadius: 4,
                  textAlign: 'center',
                  minHeight: '100%',
                  borderWidth: 3,
                  borderColor: '#626262',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Dedicated Support Team"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 600, fontSize: '18px !important', mb: 1 }}
                >
                  Dedicated Support Team
                </Typography>
                <Typography variant="body1">
                  {' '}
                  Have questions? Our expert team is available to help you
                  navigate any filing challenges.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to simplify your Mississippi W-2 filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Sign up with TaxZerone today and file Mississippi state W-2 forms for
          just <span style={{ color: '#effe05', fontWeight: 700 }}>$0.99</span>{' '}
          each!
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2ms`}
          >
            E-File W-2 Form Now!
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Does Mississippi require W-2 filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b> Yes</b>, Mississippi mandates W-2 filing for employers
                    when there has been state tax withholding. Employers must
                    file W-2 forms with the Mississippi Department of Revenue
                    (DOR) and provide copies to employees as required.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What is the deadline for filing Form W-2 in Mississippi?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      The deadline for filing Form W-2 in Mississippi is{' '}
                      <b>January 31st</b> each year.
                    </Typography>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{
                        mt: 2,
                        mb: 0,
                        textAlign: 'left',
                        borderLeft: '3px solid rgb(102, 60, 0)',
                      }}
                    >
                      <b>Note:</b> For tax year 2025, the deadline is February
                      2, 2026, because January 31<sup>st</sup> falls on
                      Saturday.
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What are the penalties for late filing in Mississippi?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{}}>
                      <ul style={{ marginBottom: 16 }}>
                        <li style={{ marginBottom: 8 }}>
                          <b>Penalty Amount:</b> If you fail to pay the taxes
                          due by the deadline, there is a <b>10% penalty</b> on
                          the tax due.
                        </li>
                        <li style={{ marginBottom: 8 }}>
                          <b> Interest Rate:</b> Additionally, interest is
                          charged at
                          <b> 0.5% per month</b> from the date the tax was due
                          until the payment is made.
                        </li>
                      </ul>
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Is there any additional form required when filing W-2s in
                  Mississippi?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography sx={{ mt: 1 }}>
                      When submitting W-2s online in Mississippi, no additional
                      forms are required. For paper filings, be sure to attach
                      Form 89-140. With <b>TaxZerone</b>, W-2s can be filed
                      electronically in a fast and easy way, helping you stay
                      compliant with state regulations and ensuring a smooth
                      filing process.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Can I file Form W-2 electronically in Mississippi through
                  TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b>Yes</b>, in Mississippi, you can electronically file both
                    federal and state W-2 forms through TaxZerone. By{' '}
                    <Link
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2ms`}
                      sx={{ color: '#0202ff' }}
                    >
                      creating a FREE account
                    </Link>
                    , you can file your W-2 forms online before the due date,
                    ensuring timely filing and compliance with all necessary
                    regulations.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Can I file Form W-2c online in Mississippi via TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b> Yes</b>, you can{' '}
                    <Link
                      href="/information-returns/efile-irs-form-w2-c/"
                      sx={{ color: '#0202ff' }}
                    >
                      file Form W-2c
                    </Link>{' '}
                    online in Mississippi via TaxZerone. This platform makes
                    filing easy and efficient, ensuring your corrections are
                    submitted accurately and on time.
                  </Typography>
                </Box>
              </Box>

              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  7. Where should I mail Form 89-140 if I’m filing by paper?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                      If you&apos;re submitting Form 89-140 with a paper return,
                      mail it along with copies of the required information
                      returns to:
                    </Typography>
                    <Box
                      sx={{
                        maxWidth: 300,
                        mb: 1,
                        p: 2,
                        border: '5px solid transparent',
                        borderRadius: 3,
                        background:
                          'linear-gradient(#fcf6bd) padding-box, repeating-linear-gradient(-45deg, #C8102E 0, #C8102E 12.5%, #ffffff 0, #ffffff 25%, #3492b8 0, #3492b8 37.5%, #ffffff 0, #ffffff 50%) 0 / 5em 5em',
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, mb: 0.8 }}
                      >
                        {' '}
                        <MailOutlineOutlinedIcon
                          sx={{
                            position: 'relative',
                            ml: 0,
                            mr: 0.5,
                            mb: -1,
                            fontSize: 28,
                          }}
                        />{' '}
                        Mailing Address:
                      </Typography>
                      <Box
                        component="div"
                        sx={{ textAlign: 'left', fontSize: '15px important' }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ fontStyle: 'italic' }}
                        >
                          Mississippi Department of Revenue,
                          <br />
                          Withholding Tax Division,
                          <br />
                          P.O. Box 23058,
                          <br />
                          Jackson, MS 39225-3058.
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FormW2Mississippi;
